import type { Registry } from '../core/registry';
import { browserDefinition } from './browser';
import { audioInputDefinition } from './audioInput';
import { cameraDefinition } from './camera';
import { testSignalDefinition } from './diagnostics/testSignal';
import { displayCaptureDefinition } from './displayCapture';
import { colorDefinition, shapeDefinition } from './graphics';
import { imageDefinition } from './image';
import { mediaDefinition } from './media';
import { playlistDefinition } from './playlist';
import { remoteGuestDefinition } from './remoteGuest';
import { clockDefinition, countdownDefinition, textDefinition, tickerDefinition } from './textSources';

export { createSourceManager } from './manager';
export { getLiveTrackIngestion, setLiveTrackIngestion, type LiveTrackIngestion } from './trackIngest';
export { expectsContinuousFrames, hasFrameStats, type FrameStats, type FrameStatsProvider } from './frameStats';

export function registerBuiltinSources(registry: Registry): void {
  registry.registerSource(browserDefinition);
  registry.registerSource(cameraDefinition);
  registry.registerSource(audioInputDefinition);
  registry.registerSource(displayCaptureDefinition);
  registry.registerSource(imageDefinition);
  registry.registerSource(mediaDefinition);
  registry.registerSource(playlistDefinition);
  registry.registerSource(textDefinition);
  registry.registerSource(clockDefinition);
  registry.registerSource(countdownDefinition);
  registry.registerSource(tickerDefinition);
  registry.registerSource(colorDefinition);
  registry.registerSource(shapeDefinition);
  registry.registerSource(remoteGuestDefinition);
  // Listed in Add Source only in diagnostics mode (definition.diagnostic).
  registry.registerSource(testSignalDefinition);
}
